/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './tournament.component.scss.shim.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '@angular/common';
import * as import3 from '@angular/router';
import * as import4 from '../../../app/+tournament/tournament.component';
import * as import5 from '@ngrx/store/src/store';
const styles_TournamentComponent:any[] = [import0.styles];
export const RenderType_TournamentComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 0,
  styles: styles_TournamentComponent,
  data: {}
}
);
function View_TournamentComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'button',[[
        'class',
        'restart'
      ]
      ],(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      var co:any = v.component;
      if (('click' === en)) {
        const pd_0:any = ((<any>co.startTournament()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Restart tournament']))
  ]
  ,(null as any),(null as any));
}
export function View_TournamentComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(2,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),19,'header',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    Tournament\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵand(8388608,(null as any),(null as any),2,(null as any),View_TournamentComponent_1)),
    import1.ɵdid(8192,(null as any),0,import2.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    import1.ɵpid(65536,import2.AsyncPipe,[import1.ChangeDetectorRef]),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),5,'button',[
      [
        'routerLink',
        '/players'
      ]
      ,
      [
        'routerLinkActive',
        'hidden'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,10).onClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
      import1.ɵdid(8192,[[
        1,
        4
      ]
    ],0,import3.RouterLink,[
      import3.Router,
      import3.ActivatedRoute,
      [
        8,
        (null as any)
      ]
      ,
      import1.Renderer,
      import1.ElementRef
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    import1.ɵdid(860160,(null as any),2,import3.RouterLinkActive,[
      import3.Router,
      import1.ElementRef,
      import1.Renderer,
      import1.ChangeDetectorRef
    ]
      ,{routerLinkActive: [
        0,
        'routerLinkActive'
      ]
    },(null as any)),
    import1.ɵqud(301989888,1,{links: 1}),
    import1.ɵqud(301989888,2,{linksWithHrefs: 1}),
    (l()(),import1.ɵted((null as any),['Edit players'])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'button',[
      [
        'class',
        'post-hidden'
      ]
      ,
      [
        'routerLink',
        '/'
      ]

    ]
      ,(null as any),[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import1.ɵnov(v,17).onClick()) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import1.ɵdid(8192,(null as any),0,import3.RouterLink,[
      import3.Router,
      import3.ActivatedRoute,
      [
        8,
        (null as any)
      ]
      ,
      import1.Renderer,
      import1.ElementRef
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['Close'])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),4,'content',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(8388608,(null as any),(null as any),1,'router-outlet',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    import1.ɵdid(73728,(null as any),0,import3.RouterOutlet,[
      import3.RouterOutletMap,
      import1.ViewContainerRef,
      import1.ComponentFactoryResolver,
      [
        8,
        (null as any)
      ]

    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n\n']))
  ]
  ,(ck,v) => {
    var co:import4.TournamentComponent = v.component;
    const currVal_0:any = import1.ɵunv(v,6,0,import1.ɵnov(v,7).transform(co.canRestart));
    ck(v,6,0,currVal_0);
    const currVal_1:any = '/players';
    ck(v,10,0,currVal_1);
    const currVal_2:any = 'hidden';
    ck(v,11,0,currVal_2);
    const currVal_3:any = '/';
    ck(v,17,0,currVal_3);
  },(null as any));
}
function View_TournamentComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'ept-tournament',([] as any[]),(null as any),(null as any),(null as any),View_TournamentComponent_0,RenderType_TournamentComponent)),
    import1.ɵdid(57344,(null as any),0,import4.TournamentComponent,[import5.Store],(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const TournamentComponentNgFactory:import1.ComponentFactory<import4.TournamentComponent> = import1.ɵccf('ept-tournament',import4.TournamentComponent,View_TournamentComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/$$_gendir/app/+tournament/tournament.component.ngfactory.ts